module.exports = __webpack_public_path__ + "static/jared_di_carlo-69d5cf58d59b07f569f2798c0efc9a6b.png";